import React from 'react';
import styles from './TypingMessage.module.scss';
import { convertMarkdownToHTML } from './factory/convertMarkdownToHTML';

const TypingMessage = ({ text }) => {
  const html = convertMarkdownToHTML(text);

  return (
    <div
      className={styles['text-message']}
      dangerouslySetInnerHTML={{ __html: html }}
      dir='auto'
    />
  );
};

export default TypingMessage;
